import { Box, Button, styled, Typography, useTheme } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { blueTick, dummyNft6 } from "../assets";
import { CLAIMABLE, nftTempImage, ON_LEND, ON_RENT } from "../constants";
import { tokens } from "../theme";
import { conciseAddress } from "../utils/formatters";

const StyledButton = styled(Button)(({ theme, colors, selected }) => ({
  backgroundColor: selected ? colors.primary[500] : "#BBBBBB",
  color: selected ? colors.whiteAccent[900] : colors.whiteAccent[900],
  fontSize: "8px",
  fontWeight: 400,
  width: "100%",
  height: "17px",
  borderRadius: "3px",
  borderColor: "#BBBBBB",
  "&:hover": {
    backgroundColor: colors.primary[600],
    borderColor: colors.primary[500],
    color: colors.whiteAccent[900],
  },
}));

const CardWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "15px 7px 15px 7px",
  //   marginLeft: "25px",
  //   paddingTop: "10px",
  backgroundColor: theme.palette.secondary.dark,
  width: "117px",
  //   height: "158px",
  borderRadius: "6px",
  boxShadow: "0px 15px 30px rgba(118, 118, 118, 0.2)",
}));

const StatusStyle = (status) => {
  switch (status) {
    case ON_LEND:
      return {
        border: "#FFE28F",
        bgColor: "rgba(255, 226, 143, 0.1)",
      };
    case ON_RENT:
      return {
        border: "#FFE28F",
        bgColor: "rgba(255, 226, 143, 0.1)",
      };
    case CLAIMABLE:
      return {
        border: "#E430D1",
        bgColor: "rgba(228, 48, 209, 0.1)",
      };
    default:
      return {
        border: "#30E46D",
        bgColor: "rgba(48, 228, 109, 0.1)",
      };
  }
};

const StatusBox = styled(Box)(({ theme, status }) => ({
  width: "90px",
  height: "20px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  // border: `1px solid ${status === ON_LEND ? "#FFE28F" : "#30E46D"}`,
  border: `1px solid ${StatusStyle(status).border}`,
  backgroundColor: `${StatusStyle(status).bgColor}`,
  borderRadius: "3px",
}));

export const GamePreview = ({
  image,
  collectionName,
  //   name,
  //   tokenId,
  //   status,
  //   address,
  //   selected,
  key,
  //   index,
  //   currNft,
  //   profileNfts,
  //   setNftStaesOnSelect,
  //   setFilteredNfts,
  //   forScholar = false,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  return (
    <CardWrapper key={key}>
      <img
        src={image}
        alt={"nft"}
        // onClick={() =>
        //   !forScholar && navigate(`/collections/${address}/${tokenId}`)
        // }
        onError={(e) => (e.currentTarget.src = nftTempImage)}
        style={{
          width: "108px",
          height: "113px",
          borderRadius: "5px",
          //   marginBottom: "10px",
          cursor: "pointer",
        }}
      />
      <Box
        display="flex"
        flexDirection="row"
        width="100%"
        marginBottom="5px"
        justifyContent="space-between"
      >
        <Box display="flex" flexDirection="column">
          <Box display="flex" flexDirection="row">
            <Typography
              variant="fs9"
              color={colors.black[500]}
              fontWeight={500}
              //   pl={1}
            >
              {collectionName || "-"}
            </Typography>
            {/* <img
              src={blueTick}
              style={{ marginLeft: "10px" }}
              alt={"blue tick"}
            /> */}
          </Box>
          {/* <Typography
            variant="fs14"
            color={colors.black[500]}
            fontWeight={500}
            pl={1}
          >
            {`#${tokenId}`}
          </Typography> */}
        </Box>
        {/* <StatusBox status={status}>
          <Typography
            variant="fs11"
            color={colors.black[500]}
            fontWeight={500}
            pl={1}
          >
            {status}
          </Typography>
        </StatusBox> */}
      </Box>

      {/* <Box
        display="flex"
        flexDirection="row"
        width={"100%"}
        justifyContent="space-between"
      >
        <Typography
          variant="fs14"
          width={"100%"}
          color={colors.black[500]}
          fontWeight={500}
          pl={1}
        >
          Address
        </Typography>

        <Typography
          variant="fs14"
          width={"100%"}
          color={colors.black[500]}
          fontWeight={500}
          align="right"
          pl={1}
        >
          {conciseAddress(address)}
        </Typography>
      </Box> */}

      <Box
        display="flex"
        flexDirection="row"
        width="100%"
        // marginBottom="5px"
        alignItems={"center"}
        justifyContent={"space-between"}
        // pl={1}
      >
        <StyledButton
          //   onClick={() => {
          //     let copyData = [...profileNfts];
          //     console.log("copyData", { copyData, profileNfts });
          //     copyData[index] = {
          //       ...currNft,
          //       selected: !currNft.selected,
          //     };
          //     // copyData = copyData.map()
          //     console.log("copyData after", copyData);
          //     if (setFilteredNfts) setFilteredNfts(copyData);
          //     setNftStaesOnSelect(copyData, currNft);
          //   }}
          variant="outlined"
          colors={colors}
          //   selected={selected ? true : currNft.selected ? true : false}
          //   disabled={
          //     (currNft.status === ON_LEND || currNft.status === ON_RENT) &&
          //     !forScholar
          //   }
        >
          {"Select"}
        </StyledButton>
      </Box>
    </CardWrapper>
  );
};
